import Vue from "vue";
export default {
  addBenefitAndDeductionType(_, payload) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post(
          `payroll/benefit-and-deduction/settings/benefit-deduction-types`,
          payload
        )
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  editBenefitAndDeductionType(_, payload) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .put(
          `payroll/benefit-and-deduction/settings/benefit-deduction-types`,
          payload
        )
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  deleteBenefitAndDeductionType(_, ids) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .delete(
          `payroll/benefit-and-deduction/settings/benefit-deduction-types/[${ids}]`
        )
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getBenefitAndDeductionType({ commit, state }) {
    const params = {
      page: state.benefitAndDeductionTypesCurrentPage,
      perPage: state.benefitAndDeductionTypesPerPage,
      ...(state.searchQuery != "" && { search_query: state.searchQuery }),
    };
    commit("tableLoading", true);
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`payroll/benefit-and-deduction/settings/benefit-deduction-types`, {
          params,
        })
        .then(response => {
          const benefitAndDeductionTypesFormatted = response.data.results.map(
            x => ({
              ...x,
              is_deduction: !x.is_deduction ? "Benefit" : "Deduction",
            })
          );
          commit("tableLoading", false);
          commit("benefitAndDeductionTypes", benefitAndDeductionTypesFormatted);
          commit("benefitAndDeductionTypesTotal", response.data.total);
          resolve(response);
        })
        .catch(error => {
          commit("tableLoading", false);
          reject(error);
        });
    });
  },
  getBenefitAndDeductionTypeById(_, id) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(
          `payroll/benefit-and-deduction/settings/benefit-deduction-types/${id}`
        )
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  handleSizeChangeForBenefitAndDeductionTypes({ commit, dispatch }, perPage) {
    commit("benefitAndDeductionTypesPerPage", perPage);
    commit("benefitAndDeductionTypesCurrentPage", 1);
    dispatch("getBenefitAndDeductionType");
  },

  handleCurrentChangeForBenefitAndDeductionTypes({ commit, dispatch }, page) {
    commit("benefitAndDeductionTypesCurrentPage", page);
    dispatch("getBenefitAndDeductionType");
  },
  getBenefitAndDeduction({ commit, state }) {
    const params = {
      page: state.benefitAndDeductionCurrentPage,
      per_page: state.benefitAndDeductionPerPage,
      ...(state.searchQuery != "" && { search_query: state.searchQuery }),
    };
    commit("tableLoading", true);
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`payroll/benefit-and-deduction`, {
          params,
        })
        .then(response => {
          const benefitAndDeductionTypesFormatted = response.data.results.map(
            x => ({
              ...x,
              type: !x.is_deduction ? "Benefit" : "Deduction",
            })
          );
          commit("tableLoading", false);
          commit("benefitAndDeduction", benefitAndDeductionTypesFormatted);
          commit("benefitAndDeductionTotal", response.data.total);
          resolve(response);
        })
        .catch(error => {
          commit("tableLoading", false);
          reject(error);
        });
    });
  },
  addBenefitAndDeduction(_, payload) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post(`payroll/benefit-and-deduction`, payload)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  editBenefitAndDeduction(_, payload) {
    return new Promise((resolve, reject) => {
      const id = payload && payload.id;
      Vue.$http
        .put(
          id
            ? `payroll/benefit-and-deduction/${id}`
            : `payroll/benefit-and-deduction`,
          payload
        )
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getBenefitAndDeductionById(_, id) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`payroll/benefit-and-deduction/${id}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  deleteBenefitAndDeduction(_, ids) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .delete(`payroll/benefit-and-deduction/[${ids}]`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  handleSizeChangeForBenefitAndDeduction({ commit, dispatch }, perPage) {
    commit("benefitAndDeductionPerPage", perPage);
    commit("benefitAndDeductionCurrentPage", 1);
    dispatch("getBenefitAndDeduction");
  },

  handleCurrentChangeForBenefitAndDeduction({ commit, dispatch }, page) {
    commit("benefitAndDeductionCurrentPage", page);
    dispatch("getBenefitAndDeduction");
  },

  getBenefitAndDeductionApproval({ commit, state }) {
    const params = {
      page: state.approvalCurrentPage,
      per_page: state.approvalPerPage,
      ...(state.searchQuery != "" && { search_query: state.searchQuery }),
    };
    commit("tableLoading", true);
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`payroll/benefit-and-deduction/approvals`, {
          params,
        })
        .then(response => {
          commit("tableLoading", false);
          const benefitAndDeductionFormatted = response.data.results.map(x => ({
            ...x,
            type: !x.is_deduction ? "Benefit" : "Deduction",
          }));
          commit("approvals", benefitAndDeductionFormatted);
          commit("approvalsTotal", response.data.total);
          resolve(response);
        })
        .catch(error => {
          commit("tableLoading", false);
          reject(error);
        });
    });
  },

  approveBenefitAndDeduction(_, ids) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post(`payroll/benefit-and-deduction/approve`, ids)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  rejectBenefitAndDeduction(_, ids) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post(`payroll/benefit-and-deduction/reject`, ids)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  handleSizeChangeForApproval({ commit, dispatch }, perPage) {
    commit("approvalPerPage", perPage);
    commit("approvalCurrentPage", 1);
    dispatch("getBenefitAndDeductionApproval");
  },

  handleCurrentChangeForApproval({ commit, dispatch }, page) {
    commit("approvalCurrentPage", page);
    dispatch("getBenefitAndDeductionApproval");
  },
};
